<template>
  <controller-frame title="Setting" v-if="mode === 'setting'">
    <div class="Setting">
      <div class="item">
        <a class="btn" @click="saveLog">全ログ保存 (TEXT)</a>
        <a class="btn" @click="saveHTMLLog">全ログ保存 (HTML)</a>
        <a class="btn" @click="saveMainLog">メインログ保存 (TEXT)</a>
        <a class="btn" @click="saveMainHTMLLog">メインログ保存 (HTML)</a>
        <a class="btn" @click="clearLog">全ログ消去</a>
      </div>
      <div class="item">
        <!-- <a class="btn" @click="setDiceType('frost')" >フロストダイスビジュアル使用</a> -->
        <!-- <a class="btn" @click="setDiceType('clear')" >クリアダイスビジュアル使用</a> -->
        <!-- <a class="btn" @click="setDiceType('default')" >どどんとふダイスビジュアル使用</a> -->
        <a v-if="enableDiceImg" class="btn" @click="changeEnableDiceImg(false)" >ダイス表示切替（現在有効）</a>
        <a v-else class="btn" @click="changeEnableDiceImg(true)" >ダイス表示切替（現在無効）</a>
        <a v-if="enableDiceSe" class="btn" @click="changeEnableDiceSe(false)" >ダイス SE 切替（現在有効）</a>
        <a v-else class="btn" @click="changeEnableDiceSe(true)" >ダイス SE 切替（現在無効）</a>
      </div>
      <div class="item">
        <a class="btn" href="https://seesaawiki.jp/trpg_tool_guide/d/%a5%b3%a5%b3%a5%d5%a5%a9%a5%ea%a5%a2%a4%ce%bb%c8%a4%a4%ca%fd" target="_blank">ガイド</a>
        <a class="btn" href="https://twitter.com/ccfolia" target="_blank">公式Twitter</a>
        <a class="btn" href="https://discord.gg/pnxPnxD" target="_blank">お問い合わせ(Discord)</a>
      </div>
      <div class="item">
        <a v-if="role !== 10" class="btn" @click="changeRole(10)">KP・GMモードに切り替え</a>
        <a v-if="role !== 5" class="btn" @click="changeRole(5)">PLモードに切り替え</a>
        <!-- <a href="">見学</a> -->
      </div>
    </div>
  </controller-frame>
</template>

<script>
import controllerFrame from '../frames/controller'

export default {
  components: { 'controller-frame': controllerFrame },
  computed: {
    mode() {
      return this.$store.getters['local/mode']
    },
    role() {
      return this.$store.getters['local/role']
    },
    roleName() {
      return this.$store.getters['local/roleName']
    },
    enableDiceImg() {
      return this.$store.getters['local/enableDiceImg']
    },
    enableDiceSe() {
      return this.$store.getters['local/enableDiceSe']
    },
    diceType() {
      return this.$store.getters['local/diceType']
    },
  },
  methods: {
    async saveLog() {
      await this.$store.dispatch('messages/toTextData').then((res) => {
        const blob = new Blob([res], {type: "text/plain"})
        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.target = '_blank'
        a.download = `log-${Date.now()}.txt`
        a.click()
        URL.revokeObjectURL(a.href)
      })
      await this.$store.dispatch('messages/log', `ログが出力されました。`, { root: true })
    },
    async saveHTMLLog() {
      await this.$store.dispatch('messages/toHTMLData').then((res) => {
        const blob = new Blob([res], {type: "text/html"})
        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.target = '_blank'
        a.download = `log-${Date.now()}.html`
        a.click()
        URL.revokeObjectURL(a.href)
      })
      await this.$store.dispatch('messages/log', `ログが出力されました。`, { root: true })
    },
    async saveMainLog() {
      await this.$store.dispatch('messages/toMainTextData').then((res) => {
        const blob = new Blob([res], {type: "text/plain"})
        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.target = '_blank'
        a.download = `log-${Date.now()}.txt`
        a.click()
        URL.revokeObjectURL(a.href)
      })
      await this.$store.dispatch('messages/log', `ログが出力されました。`, { root: true })
    },
    async saveMainHTMLLog() {
      await this.$store.dispatch('messages/toMainHTMLData').then((res) => {
        const blob = new Blob([res], {type: "text/html"})
        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.target = '_blank'
        a.download = `log-${Date.now()}.html`
        a.click()
        URL.revokeObjectURL(a.href)
      })
      await this.$store.dispatch('messages/log', `ログが出力されました。`, { root: true })
    },
    clearLog() {
      if (window.confirm('全ログを削除します。この操作は取り消せません。')) {
        this.$store.dispatch('messages/$removeAll')
      }
    },
    changeRole(value) {
      this.$store.commit('local/set', { key: 'role', value })
      if (value < 10) {
        this.$store.commit('local/set', { key: 'tableEdit', value: false })
      }
      const { roleName } = this
      this.$store.dispatch('messages/log', `${roleName}モードが選択されました。`)
    },
    changeEnableDiceImg(value) {
      this.$store.commit('local/set', { key: 'enableDiceImg', value })
      this.$store.commit('local/set', { key: 'diceTimestamp', value: Date.now() })
    },
    setDiceType(value) {
      this.$store.commit('local/set', { key: 'diceType', value })
    },
    changeEnableDiceSe(value) {
      this.$store.commit('local/set', { key: 'enableDiceSe', value })
      this.$store.commit('local/set', { key: 'diceTimestamp', value: Date.now() })
    }
  }
}
</script>

<style scoped>
.item {
  margin-bottom: 5px;
}
.btn {
  padding: 7px 10px;
  display: block;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  font-size: 10px;
  color: #ccc;
  text-decoration: none;
}
.btn[href] {
  color: #c88;
}
.btn[href]::after {
  content: " (外部サイト)"
}
.btn:hover {
  background: rgba(0, 0, 0, 0.2);
}
</style>
